'use strict';
angular.module('newspaperPageDraftModule', ['newspaperPageDraftRouterModule']).controller('newspaperPageDraftCtrl', [
    '$scope',
    '$state',
    '$q',
    '$filter',
    '$window',
    '$cacheFactory',
    '$stateParams',
    'trsHttpService',
    'initSingleSelecet',
    'editNewspaperService',
    'trsspliceString',
    'editingCenterService',
    'editcenterRightsService',
    'trsPrintService',
    'storageListenerService',
    'globleParamsSet',
    'localStorageService',
    '$sessionStorage',
    'modalDialog',
    'newMediaService',
    'publicToolService',
    function(
        $scope,
        $state,
        $q,
        $filter,
        $window,
        $cacheFactory,
        $stateParams,
        trsHttpService,
        initSingleSelecet,
        editNewspaperService,
        trsspliceString,
        editingCenterService,
        editcenterRightsService,
        trsPrintService,
        storageListenerService,
        globleParamsSet,
        localStorageService,
        $sessionStorage,
        modalDialog,
        newMediaService,
        publicToolService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 50,
                ITEMCOUNT: 0,
                PAGECOUNT: 0,
            };
            $scope.params = {
                serviceid: 'mlf_paper',
                methodname: 'queryShangBanDocs',
                PaperId: $stateParams.paperid,
                isPass: false
                // DocPubTime: '1m',
            };
            $scope.childStatus = {
                // 图片数组的string
                checkString: 'DOC_PICTURELIST',
                // 图片数组中表示url地址的string
                picString: 'SRCPICURL',
                originPicUrl: 'SRCPICURL'
            };
            $scope.isAllSelect = [];
            $scope.status = {
                isShowList: true,
                btnRights: {},
                batchOperateBtn: {
                    hoverStatus: '',
                    clickStatus: '',
                },
                hasphoto: false, // 是否是图集稿
                hasphotoflag: true, // 判断是否人为点击图集切换模式
                // 编辑页面
                newspaperEdit: editNewspaperService.initNewspaperEdit(),
                newspaperPreview: {
                    // 预览页
                    1: 'newspaperNewsPreview',
                    2: 'newspaperAtlasPreview',
                },
                paperId: $stateParams.paperid,
                quantitys: 0, // 未读信息数量
                // isOpen: [],
                isPanelOpenArray: {
                    0: true,
                },
                sbgpreview: 2,
                sbgedit: 2,
                message: {
                    currUnreadNum: 0, // 当前未读信息数
                    systemTime: '', // 缓存最近请求时间
                },
                isESSearch: false,
                cachedName: 'newspaperPageDraftDocuments',
                cacheOpenedPanel: {}, // 存储打开的panel
            };
            $scope.data = {
                panels: [],
                selectedArray: [],
                BanMian: {
                    selectedBanMian: {},
                    BanMianArray: [],
                },
                selectedArrayObj: [],
                word: [],
                selectAllWords: 0, // 列表下选中总字数
                ownerArr: [], // 所有者
                AllBMRights: {}, // 记录所有版面权限字段
                // 这里用于给时间指令传自定义的配置
                customConfig: {
                    singleDatePicker: true, // 是否是单选框
                },
                orderArray: editingCenterService.getNewspaperOrder(), // 下拉框排序
                selectedOrder: editingCenterService.getNewspaperOrder()[0],
                // trench: 'Newspaper'
            };
        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            initDropDown();
            // requestData();
            listenStorage();
            // 按钮权限
            editcenterRightsService.initNewspaperListBtn('paper.sbg', $stateParams.paperid).then(function(data) {
                $scope.status.btnRights = data;
                $scope.data.AllBMRights['paper.sbg'] = data;
                getObjLength($scope.status.btnRights);
            });
            // 当前报纸信息
            editingCenterService.getSiteInfo($stateParams.paperid).then(function(data) {
                $scope.data.paperMsg = data;
            });
        }
            
        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function() {
            let defer = $q.defer();
            publicToolService.getModeconfiguration('newspaperDefaultOrderByTime').then((config) => {
                $scope.data.selectedOrder = (config === 'true' ? editingCenterService.getNewspaperOrder()[1] : editingCenterService.getNewspaperOrder()[0]);
                requestData().then(() => {
                    defer.resolve();
                }, () => {
                    defer.reject();
                });
            },
            () => {
                requestData().then(() => {
                    defer.resolve();
                }, () => {
                    defer.reject();
                });
            });
            return defer.promise;
        };
        
        /**
         * [xiuding description]修订
         * @return {[type]} [description]
         */
        $scope.xiuding = function() {
            var transferData = {
                serviceid: 'mlf_papermodify',
                methodname: 'appointDocToUserOfSbg',
                PaperId: $stateParams.paperid,
                PaperDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                selectedArray: $scope.data.selectedArray
            };
            newMediaService.revise($scope, transferData);
        };

        /**
         * [getReviseInfo description] 获取修订信息
         * @return {[type]} [description]
         */
        $scope.getReviseInfo = newMediaService.getReviseInfo;

        /**
         * [getObjLength description] 获取对象长度
         * @param   {[obj]}  obj  [obj description] 传入的对象
         * @return  {[type]}      [return description]
         */
        function getObjLength(obj) {
            var size = 0,
                key;
            for (key in obj) {
                if (obj.hasOwnProperty(key)) {
                    size++;
                }
            }
            $scope.status.btnLength = size;
        }

        /**
         * [getSystemTime description]获取系统时间
         * @return {[promise]} [description]promise
         */
        function getSystemTime() {
            globleParamsSet.getServerTime().then((data) => {
                $scope.status.message.systemTime = data.LASTOPERTIME;
            });
        }

        /**
         * [requestData description] 请求数据
         * @return  {[type]}  [return description]
         */
        function requestData() {
            var deferred = $q.defer();
            var params = $scope.status.isESSearch ? getESSearchParams() : angular.copy($scope.params);
            if ($scope.status.isShowList) {
                params.PageSize = $scope.page.PAGESIZE;
                params.CurrPage = $scope.page.CURRPAGE;
                if (!$scope.status.isESSearch) {
                    params.NoPage = !$scope.status.isESSearch && $scope.status.isShowList;
                    params.ChannelId = $scope.data.BanMian.selectedBanMian.CHANNELID;
                }
            } else {
                params.ChannelId = '';
            }
            params.OrderType = $scope.data.selectedOrder.value;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.selectedArray = [];
                var fileterObj = {};
                if ($scope.status.isShowList) {
                    $scope.data.selectAllWords = 0;
                    $scope.data.items = $scope.data.panels = data.DATA;
                    if ($scope.data.selectedDocType.value && $scope.data.selectedDocType.value === '2' && $scope.status.hasphotoflag === true) {
                        $scope.status.hasphoto = true;
                    } else {
                        $scope.status.hasphoto = false;
                    }
                    $scope.page = data.PAGER;
                    fileterObj = editNewspaperService.extractParametersList(data.DATA, {
                        namekey: 'OWNERTRUENAME',
                        valuekey: 'OWNERNAME',
                        title: '所有者'
                    });
                    $scope.data.ownerArr = $scope.data.ownerArr.concat(fileterObj.nameArr);
                    $scope.data.ownerArr = $filter('unique')($scope.data.ownerArr, 'name');
                    // $scope.data.filterReviseItem = fileterObj.filterReviseItem; // 因为待修订稿件不能被选中,用来存储非待修订的稿件
                    if ($scope.data.items.length) {
                        editingCenterService.queryVerifyDoc($scope.data.items).then(function(data) {
                            $scope.data.filterReviseItem = $scope.data.items.filter((item) => item.PAPERSTATUSNAME !== '待修订' && item.verifyDocIsCanOper);
                        });
                    }
                    editNewspaperService.liebiaoListItemCache(data.DATA);
                } else {
                    $scope.status.hasphoto = false;
                    fileterObj = editNewspaperService.extractParameters(data, {
                        namekey: 'OWNERTRUENAME',
                        valuekey: 'OWNERNAME',
                        title: '所有者'
                    });
                    $scope.data.ownerArr = fileterObj.nameArr;
                    $scope.data.ownerArr = $filter('unique')($scope.data.ownerArr, 'name');
                    cacheDate(data);
                    // 刷新版面列表;
                    if (data.length > 0) {
                        $scope.data.word = editNewspaperService.getWordNum(data);
                        openDefaultPanels();
                    }
                    getSystemTime(); // 获取上次刷新时间
                }
                if (!$scope.data.selectOwner) {
                    $scope.data.selectOwner = $scope.data.ownerArr[0];
                }
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [openDefaultPanels description]打开默认PANEL
         * @return {[type]} [description]
         */
        function openDefaultPanels() {
            var tempOpenedPanels = editNewspaperService.getCacheOpenedPanel('sbg');

            if (angular.isUndefined(tempOpenedPanels)) {
                $scope.status.isPanelOpenArray[0] = true;
                if ($scope.data.panels[0].DOCUMENTS.length) {
                    editingCenterService.queryVerifyDoc($scope.data.panels[0].DOCUMENTS);
                }
                return;
            }
            $scope.status.isPanelOpenArray[0] = false;
            for (var i in $scope.data.panels) {
                if (tempOpenedPanels[$scope.data.panels[i].DATE + $scope.data.panels[i].BANMIANID] === true) {
                    $scope.status.isPanelOpenArray[i] = true;
                    getCachedById(i);
                }
            }
        }

        // 监听预览页 按钮点击
        $window.addEventListener('storage', function(e) {
            // pagedraft
            $scope.data.selectedCurrents = angular.copy(localStorageService.get('newspaperPreviewSelectArray')); // page
            $scope.$apply(function() {
                selectCurArray($scope.data.selectedCurrents);
            });
        });

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenNewspaper(function() {
                $scope.page.CURRPAGE = 1;
                requestData();
                storageListenerService.removeListener('newspaper');
            }, $scope);
            $scope.$on('$destroy', function() {
                localStorageService.remove('newspaperPreviewSelectArray');
                localStorageService.remove('newspaperPreviewCache');
            });
        }

        /**
         * [cacheDate description] 缓存数据以提高渲染速度
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function cacheDate(data) {
            if ($cacheFactory.get($scope.status.cachedName)) {
                $cacheFactory.get($scope.status.cachedName).destroy();
            }
            var copyedData = angular.copy(data);
            var cache = $cacheFactory($scope.status.cachedName);
            var documents = [];
            for (var i in copyedData) {
                cache.put(copyedData[i].BANMIANID + copyedData[i].DATE, copyedData[i].DOCUMENTS);
                documents.push(copyedData[i].DOCUMENTS);
                if (i > 0) {
                    copyedData[i].DOCUMENTS = [];
                }
                // copyedData[i].INDEXID=i;
            }
            $scope.data.panels = copyedData;
            listItemCache(documents);
        }

        /**
         * [listItemCache description] 缓存存储
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function listItemCache(data) {
            var cachePreviewMetadataid = [];
            $scope.data.selectedArrayObj = [];
            angular.forEach(data, function(data, index, array) {
                angular.forEach(data, function(_data, _index, _array) {
                    cachePreviewMetadataid.push({
                        METADATAID: _data.METADATAID,
                        PAPERSTATUSNAME: _data.PAPERSTATUSNAME,
                        NEWSPAPERTYPE: 2,
                    });
                    $scope.data.selectedArrayObj.push(_data);
                });
            });
            localStorageService.set('newspaperPreviewCache', cachePreviewMetadataid);
        }

        /**
         * [selectCurArray description] 遍历出选择对象
         * @param   {[array]}  curSelectedArray  [curSelectedArray description] 遍历出选择对象
         * @return  {[type]}                     [return description]
         */
        function selectCurArray(curSelectedArray) {
            // o
            if (curSelectedArray === null) {
                return;
            }
            // var arrays=[];
            $scope.data.selectedArray = [];
            for (var i = 0; i < curSelectedArray.length; i++) {
                for (var j = 0; j < $scope.data.selectedArrayObj.length; j++) {
                    if (curSelectedArray[i] === $scope.data.selectedArrayObj[j].METADATAID) {
                        $scope.data.selectedArray.push($scope.data.selectedArrayObj[j]);
                    }
                }
            }
        }

        /**
         * [selectItem description] 单选某稿件
         * @param   {[obj]}  item   [item description]  稿件信息
         * @param   {[type]}  items  [items description]
         * @return  {[type]}         [return description]
         */
        $scope.selectItem = function(item, items) {
            var num = -1;
            for (var index = 0; index < $scope.data.selectedArray.length; index++) {
                if ($scope.data.selectedArray[index].METADATAID === item.METADATAID) {
                    num = index;
                    break;
                }
            }
            if (num > -1) {
                $scope.data.selectedArray.splice(num, 1);
            } else {
                $scope.data.selectedArray.push(item);
            }
            // 选中的报纸的字数
            var selectedNum = 0;
            $scope.data.selectedArray.map((item) => {
                if (items.DOCUMENTS.includes(item)){
                    selectedNum = selectedNum + Number(item.DOCWORDSCOUNT);
                }
            });
            $scope.data.word[$scope.data.panels.indexOf(items)].selcetedWord = selectedNum;

            selectedArrayCahe($scope.data.selectedArray);
            $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, item.CHANNELID, 'paper.sbg').then(function(data) {
                $scope.status.btnRights = data;
            });
        };

        /**
         * [selectAllItem description] 全选或者取消全选的操作
         * @return  {[type]}  [return description]
         */
        $scope.selectAllItem = function() {
            if ($scope.data.selectedArray.length === $scope.data.shangbanDocList.length && $scope.data.shangbanDocList.length > 0) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [];
                for (var i = 0; i < $scope.data.shangbanDocList.length; i++) {
                    $scope.data.selectedArray.push($scope.data.shangbanDocList[i]);
                }
            }
            selectedArrayCahe($scope.data.selectedArray);
        };

        /**
         * [selectedArrayCahe description] 缓存当前选中项
         *
         * @param   {[array]}  array  [array description] 选中对象
         * @return  {[type]}         [return description]
         */
        function selectedArrayCahe(array) {
            var selectedArray = angular.copy(array);
            var selectedArrayMetadaid = [];
            angular.forEach(selectedArray, function(data, index) {
                selectedArrayMetadaid.push(data.METADATAID);
            });
            localStorageService.set('newspaperPreviewSelectArray', selectedArrayMetadaid); // paged
        }

        /*
         * [isChecked description] 点击单选
         * @item {[type]} [description]  当前选择值
         */
        $scope.isChecked = function(item) {
            // page
            return getIndex(item) >= 0;
        };

        /**
         * [getIndex description] 单选方法
         * @param   {[obj]}  item  [item description] 当前选择值
         * @return  {[type]}        [return description]
         */
        function getIndex(item) {
            var selectedArray = $scope.data.selectedArray;
            for (var index = 0; index < selectedArray.length; index++) {
                if (selectedArray[index].METADATAID == item.METADATAID) {
                    return index;
                }
            }
            return -1;
        }

        /**
         * [newspaperPreview description] 报纸预览
         * @param   {[obj]}  item  [item description] 当前对象
         * @return  {[type]}        [return description]
         */
        $scope.newspaperPreview = function(item) {
            var paramsstateParams = {
                paperid: item.SITEID,
                bzmetadata: item.METADATAID,
                newspapertype: $scope.status.sbgpreview,
                paperstatusname: item.PAPERSTATUSNAME,
                channelid: item.CHANNELID
            };
            var url = $state.href('newspaperNewsPreview', paramsstateParams);
            window.open(url);
            storageListenerService.previewPageTurningStorage($scope.data.shangbanDocList, 'METADATAID,SITEID,DOCTYPEID', 'newspaperPreview'); // news
        };

        /**
         * [getCachedById description] 点击版面加载缓存的数据，以提高页面加载速度
         * @param   {[type]}  index  [index description] panel下标
         * @param   {[type]}  date   [date description]
         * @return  {[type]}         [return description]
         */
        $scope.getCachedById = function(index, date) {
            setOpenedPanel(index, date);
            if ($scope.data.panels[index].DOCUMENTS.length > 0) {
                return;
            } else {
                $scope.loadingPromise = getCachedById(index);
            }
        };

        /**
         * [setOpenedPanel description]
         * @param   {[type]}  index  [index description]
         * @return  {[type]}         [return description]
         */
        function setOpenedPanel(index) {
            for (var i in $scope.status.isPanelOpenArray) {
                if ($scope.data.panels[i]) {
                    $scope.status.cacheOpenedPanel[$scope.data.panels[i].DATE + $scope.data.panels[i].BANMIANID] = $scope.status.isPanelOpenArray[i];
                }
            }
            editNewspaperService.cacheOpenedPanel('sbg', $scope.status.cacheOpenedPanel);
        }

        /**
         * [getCachedById description] 获取对应panel下缓存的DOCUMENTS 为了展示loadingPromise
         * @param  {[type]} index [description] panel下标
         * @return {[type]}       [description] promise
         */
        function getCachedById(index) {
            var deferred = $q.defer();
            var panel = $scope.data.panels[index];
            if (angular.isDefined(panel)) {
                if (panel.DOCUMENTS.length === 0) {
                    var cache = $cacheFactory.get($scope.status.cachedName);
                    panel.DOCUMENTS = cache.get(panel.BANMIANID + panel.DATE);
                    if (panel.DOCUMENTS.length) {
                        editingCenterService.queryVerifyDoc(panel.DOCUMENTS);
                    }
                    deferred.resolve();
                } else {
                    deferred.reject();
                }
            }
            return deferred.promise;
        }

        /**
         * [promptRequest description]具体操作数据请求成功后刷新列表
         * @param  {[obj]} params [description]请求参数
         * @param  {[string]} info   [description]提示语
         * @return {[type]}        [description]
         */
        function promptRequest(params, info) {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                function(data) {
                    modalDialog.alertType('', info, 'success', false, function() {
                        requestData();
                    });
                },
                function() {
                    requestData();
                }
            );
        }
        // 分类全选
        $scope.selectAllType = function(items, index) {
            $scope.status.judgement = determineItemsInSelectedArray(items);
            if ($scope.status.judgement) {
                deleteItemsInSelectedArray(items);
                $scope.data.word[index].selcetedWord = 0;
            } else {
                addDraftInSelectedArray(items, index);
                // 选中的报纸的字数
                if (items.length == 0){
                    $scope.data.word[index].selcetedWord = $scope.data.word[index].wordAllCount;
                } else {
                    var selectedNum = 0;
                    $scope.data.selectedArray.map((item) => {

                        if (items.includes(item)){
                            selectedNum = selectedNum + Number(item.DOCWORDSCOUNT);
                        }
                    });
                    $scope.data.word[index].selcetedWord = selectedNum;
                }
            }
            $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, $scope.data.panels[index].DOCUMENTS[0].CHANNELID, 'paper.sbg').then(function(data) {
                $scope.status.btnRights = data;
            });
        };
        $scope.determineItemsInSelectedArray = function(items) {
            return determineItemsInSelectedArray(items);
        };

        /**
         * [determineItemsInSelectedArray description]
         * @param   {[type]}  items  [items description]
         * @return  {[type]}         [return description]
         */
        function determineItemsInSelectedArray(items) {
            if (items.length === 0) {
                return false;
            }
            var reviseNum = 0;
            for (var i = 0; i < items.length; i++) {
                if (items[i].PAPERSTATUSNAME !== '待修订' && $scope.data.selectedArray.indexOf(items[i]) < 0 && items[i].verifyDocIsCanOper) {
                    return false;
                } else if (items[i].PAPERSTATUSNAME === '待修订') {
                    reviseNum++;
                }
            }
            if (reviseNum === items.length) {
                return false;
            }
            return true;
        }

        /**
         * [deleteItemsInSelectedArray description]删除指点版面下所有在selectArray中的稿件
         * @param  {[array]} item [description]
         * @return {[type]}      [description]
         */
        function deleteItemsInSelectedArray(items) {
            for (var i = 0; i < items.length; i++) {
                if ($scope.data.selectedArray.indexOf(items[i]) > -1) {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(items[i]), 1);
                }
            }
        }

        /**
         * [addDraftInSelectedArray description] 向selectArray中添加元素
         * @param   {[type]}  items  [items description]
         * @param   {[type]}  index  [index description]
         * @return  {[type]}         [return description]
         */
        function addDraftInSelectedArray(items, index) {
            if (items.length === 0) {
                $scope.status.isPanelOpenArray[index] = true;
                $scope.getCachedById(index);
                items = $scope.data.panels[index].DOCUMENTS;
            }
            for (var i = 0; i < items.length; i++) {
                var index = $scope.data.selectedArray.indexOf(items[i]);
                if (index < 0 && items[i].PAPERSTATUSNAME !== '待修订' && items[i].verifyDocIsCanOper) {
                    $scope.data.selectedArray.push(items[i]);
                }
            }
        }

        // 导出稿件
        $scope.exportDraft = function() {
            editingCenterService.newsPaperExportDraft($scope);
        };

        /**
         * [initDropDown description]初始化日期，稿件类型下拉框
         * @return {[type]} [description]
         */
        function initDropDown() {
            $scope.data.selectdTime = initSingleSelecet.chooseTimeType();
            $scope.data.selectdTimeDefault = angular.copy($scope.data.selectdTime[3]);
            $scope.data.docTypeJsons = initSingleSelecet.newspaperDraftType(); // paper
            $scope.data.selectedDocType = angular.copy($scope.data.docTypeJsons[0]);
            // 初始化选择状态
            $scope.data.todayManuStatusArray = initSingleSelecet.standbyOrPageManuStatus();
            $scope.data.todayManuStatusArray.splice(1, 0, {
                name: '上版稿',
                value: '34',
            }); // 加入上版稿选项
            $scope.data.SelectedTodayManuStatus = angular.copy($scope.data.todayManuStatusArray[0]);
            // 排序方式
            $scope.sortTypeJsons = initSingleSelecet.sortType();
            $scope.sortType = angular.copy($scope.sortTypeJsons[1]);

            $scope.data.conditionsSearch = editNewspaperService.newspaperEntire();
            $scope.data.selectedConditions = angular.copy(editNewspaperService.newspaperEntire()[0]);
            
            editNewspaperService.screenFilter($state.params.paperid).then(function(data) {
                $scope.data.BanMian.BanMianArray = data;
                $scope.data.BanMian.selectedBanMian = data[0];
            });
        }

        /**
         * [queryByDropdown description]点击下拉框查询列表
         * @param  {[type]} param [description]类型
         * @param  {[type]} value [description]请求参数
         * @return {[type]}       [description]
         */
        $scope.queryByDropdown = function(param, value) {
            if (param === 'ChannelId') {
                $scope.loadingPromise = editNewspaperService.getBMRights($scope.data.AllBMRights, value, $stateParams.paperid, 'paper.sbg').then(function(data) {
                    $scope.status.btnRights = data;
                });
            }
            if (param === 'ChannelId' && !$scope.status.isShowList) {
                return;
            } else if (param === 'PubDate' && value) {
                value = $filter('date')(value, 'yyyy-MM-dd');
            }
            if (param === 'DocType' && value === '2') {
                $scope.status.hasphotoflag = true;
            }
            $scope.params[param] = value;
            $scope.page.CURRPAGE = 1;
            requestData();
        };

        /**
         * [clearDateTime description] 清空时间
         *
         * @return  {[type]}  [return description]
         */
        $scope.clearDateTime = function() {
            $scope.data.pubDate = '';
            $scope.queryByDropdown('PubDate');
        };

        /**
         * [singleSignZp description]签发照排
         * @param  {[obj]} item [description]传入的列表项或者选中的数组
         * @return {[type]}      [description]null
         */
        $scope.signedDraft = function(item) {
            newMediaService.newsSign($scope);
        };


        /**
         * [filterChnlid description]过滤版面ID
         * @param  {[obj]} elm [description]每个选中项的版面ID
         * @return {[type]}     [description]
         */
        $scope.banmianFilter = function(elm) {
            if (angular.isDefined(elm.CHNLID)) {
                return elm.CHNLID === $scope.data.selectedArray[0].CHNLID;
            }
        };

        /**
        * [zhuanban description] 转版
        * @return  {[type]}  [return description]
        */
        $scope.zhuanban = function() {
            newMediaService.zhuanBan($scope);
        };

        /**
        * [retractView description] 撤稿操作
        * @return  {[type]}  [return description]
        */
        $scope.retractView = function() {
            newMediaService.newsPaperChegao($scope);
        };

        // 稿件收藏
        $scope.batchCollect = function() {
            editNewspaperService.collectDraft($scope, 'collectShangBan');
        };

        /**
         * [draftlist description] 发稿单操作
         * @return  {[type]}  [return description]
         */
        $scope.draftlist = function() {
            newMediaService.draftlist($scope, {
                serviceid: 'mlf_appfgd',
                methodname: 'paperShangBanbatchUpdateFgdUsers',
            });
        };

        /**
         * [collectDraft description] 稿件收藏方法
         * @param   {[string]}  MetaDataIds  [MetaDataIds description] id串
         * @return  {[null]}                 [return description]
         */
        function collectDraft(MetaDataIds) {
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'collectShangBan',
                MetaDataIds: MetaDataIds,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType('', '收藏成功', 'success', false, function() {
                    requestData();
                });
            });
        }
        // 批量退稿功能
        $scope.rejection = function() {
            rejectionDraftofPage($scope.data.selectedArray);
        };
        $scope.singleRejection = function(item) {
            rejectionDraftofPage([item]);
        };

        /**
         * [rejectionDraftofPage description] 退稿方法
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function rejectionDraftofPage(item) {
            var transferData = {
                PaperId: $stateParams.paperid,
                queryMethod: $scope.params.methodname,
                item: item,
                rejecectionMethod: 'rejectionShangBanViewDatas',
            };
            editNewspaperService.rejectionDraft(
                transferData,
                function(result) {
                    requestData();
                },
                function(result) {
                    requestData();
                }
            );
        }

        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function (item) {
            $scope.selectItemList(item);
        };

        /**
         * [atlasMode description] 图集模式
         * @return {[type]} [description]
         */
        $scope.atlasMode = function() {
            // $scope.departListParams.CurrPage = $scope.page.CURRPAGE = 1;
            $scope.status.hasphoto = !$scope.status.hasphoto;
            $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
        };
        
        /**
         * [goToDetail description]图集模式跳转细览页
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.goToDetail = function(item){
            $scope.newspaperPreview(item);
        };
        
        /**
         * [printBtn description] 批量打印功能
         * @return  {[type]}  [return description]
         */
        $scope.printBtn = function() {
            const chnlDocIds = $scope.data.selectedArray.map((item) => item.CHNLDOCID).join(',');
            editingCenterService.isListDocCanOper(chnlDocIds, $scope.requestData).then(function(data){
                var chnlDocIdsArray = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: 'queryViewDatas',
                    MetaDataIds: chnlDocIdsArray,
                };

                /**
             * [requestVersion description] 请求流程
             * @return  {[type]}  [return description]
             */
                function requestVersion() {
                    var idsArray = trsspliceString.getArrayString($scope.data.selectedArray, 'METADATAID', ',').split(',');
                    var versionResult = {};
                    var count = 0;
                    var defer = $q.defer();
                    angular.forEach(idsArray, function(value, key) {
                        trsHttpService
                            .httpServer(
                                trsHttpService.getWCMRootUrl(),
                                {
                                    serviceid: 'mlf_metadatalog',
                                    methodname: 'query',
                                    MetaDataId: value,
                                },
                                'get'
                            )
                            .then(function(data) {
                                versionResult[value] = data.DATA;
                                count++;
                                if (count == idsArray.length) {
                                    defer.resolve(versionResult);
                                }
                            });
                    });
                    return defer.promise;
                }

                $scope.loadingPromise = $q
                    .all([trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get'), requestVersion()])
                    .then(function(data) {
                        var detail = data[0];
                        var version = data[1];
                        for (var i = 0; i < detail.length; i++) {
                            detail[i].VERSION = version[detail[i].METADATAID];
                            if (i + 1 == detail.length) {
                                trsPrintService.trsPrintDocument(detail);
                            }
                        }
                    });
            });
        };
        // 流程版本与操作日志
        $scope.showVersionTime = function(item) {
            editingCenterService.getVersionTime(item, false);
        };
        // 稿件关联弹窗
        $scope.draftCorrelationView = function(id) {
            editNewspaperService.draftCorrelationViews(id, $stateParams.paperid, 2);
        };

        /**
         * [archive description]归档操作
         * @return {[type]} [description]
         */
        $scope.archive = function() {
            // modalDialog.inputModel('归档', '归档意见（可选）', function(content) {
            //     modalDialog.confirmModal('归档', '确认归档所选稿件', function() {
            //         var params = {
            //             serviceid: 'mlf_paper',
            //             methodname: 'doGuiDang',
            //             Option: content,
            //             SrcDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
            //             SrcBanMianIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLID', ','),
            //         };
            //         promptRequest(params, '归档成功');
            //     });
            // });
            editNewspaperService.archive($scope.data.selectedArray,
                function(data) {
                    modalDialog.alertType('', '归档成功', 'success', false, function() {
                        requestData();
                    });
                },
                function() {
                    requestData();
                });
        };
        // 搜索
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = 1;
                $scope.status.isESSearch = true;
                $scope.status.isPanelOpenArray = {};
                requestData();
            }
        };

        /**
         * [getESSearchParams description]设置ES检索参数
         * @return {[json]} [description] 参数对象
         */
        function getESSearchParams() {
            var esParams = {
                serviceid: 'mlf_hybasesearch',
                methodname: $scope.status.isShowList ? 'queryPaperShangBanDocNoPage' : 'queryForPaperShangBanDoc',
                searchParams: {
                    PAGESIZE: $scope.page.PAGESIZE + '',
                    PAGEINDEX: $scope.page.CURRPAGE + '',
                    searchFields: [
                        {
                            searchField: $scope.data.selectedConditions.value,
                            keywords: $scope.status.keywords ? $scope.status.keywords : '',
                        },
                        {
                            searchField: 'docType',
                            keywords: $scope.data.selectedDocType.value,
                        },
                        // {
                        //     searchField: 'oprtime',
                        //     keywords: $scope.data.selectdTimeDefault.value,
                        // },
                        {
                            searchField: 'OwnerName',
                            keywords: $scope.data.selectOwner.value
                        },
                        {
                            searchField: 'paperid',
                            keywords: $stateParams.paperid,
                        },
                        {
                            searchField: '_sort',
                            keywords: $scope.sortType.value,
                        },
                        {
                            searchField: 'PubDate',
                            keywords: $scope.data.pubDate ? $filter('date')($scope.data.pubDate, 'yyyy-MM-dd') : ''
                        },
                        {
                            searchField: 'pendingState',
                            keywords: $scope.params.isPass ? '2' : '', // 只看通过传2，全部直接传空
                        },
                    ],
                },
            };
            if ($scope.status.isShowList) {
                esParams.searchParams.searchFields.push({
                    searchField: 'CHANNELID',
                    keywords: $scope.data.BanMian.selectedBanMian.CHANNELID
                });
            }
            esParams.searchParams = JSON.stringify(esParams.searchParams);
            return esParams;
        }

        // 外发
        $scope.outSending = function() {
            editingCenterService.outSending($scope.data.selectedArray, function(result) {
                outSendingDraft(result.selectItems);
            }, function(){
                $scope.requestData();
            });
        };

        /**
         * [outSendingDraft description] 邮件外发
         * @param   {[type]}  items  [items description]
         * @return  {[type]}         [return description]
         */
        function outSendingDraft(items) {
            var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
            var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
            var params = {
                serviceid: 'mlf_mailoutgoingOper',
                methodname: 'paperShangBanGaoSendEmail',
                Emails: userids,
                MetaDataIds: draftids,
            };
            promptRequest(params, '邮件外发成功');
        }

        /**
         * [isLockEdit description] 编辑前请求解锁
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.isLockEdit = function(item) {
            editingCenterService.isListDocCanOper(item.CHNLDOCID, $scope.requestData).then(function(){
                $scope.loadingPromise = editNewspaperService.getBMRights($scope.data.AllBMRights, item.CHANNELID, $stateParams.paperid, 'paper.sbg').then(function(rights) {
                    if (item.PAPERSTATUSNAME !== '待修订' && rights['paper.sbg.bianji'] && item.verifyDocIsCanOper) {
                        item.newspapertype = $scope.status.sbgedit;
                        item.MEDIATYPE = item.MEDIATYPE || '3';
                        editingCenterService.routerToEditorWithLock(item);
                    } else {
                        var url = $state.href('newspaperNewsPreview', {channelid: item.CHANNELID, paperid: item.SITEID, bzmetadata: item.METADATAID, newspapertype: $scope.status.sbgedit, paperstatusname: item.PAPERSTATUSNAME });
                        window.open(url);
                    }
                });
            });
        };

        /**
         * [manuscriptShare description] 稿件分享
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.manuscriptShare = function(item) {
            $scope.loadingPromise = editingCenterService.manuscriptShare(item, function(data) {
                requestData();
            });
        };

        $scope.draft = function() {
            var userInfo = $sessionStorage.get('curUserInfo');
            var transferUserObj = localStorageService.get('transferUser') || {};
            var records = transferUserObj[userInfo.ID];
            if (!records) {
                records = [];
            }
            editNewspaperService.draft({
                title: '传稿',
                records: records,
                confirm: true,
                selectedArray: $scope.data.selectedArray
            }, function(obj) {
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: 'transferMetaDatas',
                    paperid: $state.params.paperid,
                    transferUser: JSON.stringify({
                        'USERID': obj.ID,
                        'USERNAME': obj.UNAME,
                        'TRUENAME': obj.USERNAME
                    }),
                    metadataids: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',')
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function(data) {
                    modalDialog.multiReportsAlert(data, function(){
                        requestData();
                        delete obj.selected;
                        for (var i = 0; i < records.length; i++) {
                            if (records[i].ID === obj.ID) {
                                records.splice(i, 1);
                                records.unshift(obj);
                                transferUserObj[userInfo.ID] = records;
                                localStorageService.set('transferUser', transferUserObj);
                                return;
                            }
                        }
                        if (records.length < 4) {
                            records.unshift(obj);
                            transferUserObj[userInfo.ID] = records;
                            localStorageService.set('transferUser', transferUserObj);
                        } else {
                            records.pop();
                            records.unshift(obj);
                            transferUserObj[userInfo.ID] = records;
                            localStorageService.set('transferUser', transferUserObj);
                        }
                    });
                });
            }, function(){
                $scope.requestData();
            });
        };

        /** *************************list模式方法**************************/

        /**
         * [pageChanged description] 换页
         *
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function() {
            requestData();
        };

        /**
         * [selectAllList description] 全选，待修订不允许选中
         *
         * @return  {[type]}  [return description]
         */
        $scope.selectAllList = function() {
            $scope.data.selectAllWords = 0;
            if ($scope.data.selectedArray.length === $scope.data.filterReviseItem.length) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [].concat($scope.data.filterReviseItem);
                $scope.data.filterReviseItem.forEach(function(item) {
                    $scope.data.selectAllWords += parseInt(item.DOCWORDSCOUNT);
                });
            }
            // requireMulBMRights();
        };

        /**
         * [selectItemList description] 单选
         *
         * @param   {[type]}  item   [item description]
         * @param   {[type]}  index  [index description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.selectItemList = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index === -1) {
                $scope.data.selectedArray.push(item);
                $scope.data.selectAllWords += parseInt(item.DOCWORDSCOUNT);
            } else {
                $scope.data.selectedArray.splice(index, 1);
                $scope.data.selectAllWords -= parseInt(item.DOCWORDSCOUNT);
            }
            $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, item.CHANNELID, 'paper.sbg').then(function(data) {
                $scope.status.btnRights = data;
            });
        };

        /**
         * [changeMode description] 切换时折叠模式还是列表模式
         *
         * @return  {[type]}  [return description]
         */
        $scope.changeMode = function() {
            // $scope.page.PAGESIZE = 50;
            $scope.page.CURRPAGE = 1;
            $scope.data.panels = [];
            $scope.status.isShowList = !$scope.status.isShowList;
            requestData();
        };

        /**
         * [isOnlyMine description] 只看通过
         *
         * @param {[type]} key   [key description] 代表是改变通过还是我的的状态
         *
         * @return {[type]}   [return description] null
         */
        $scope.isOnlyMine = function(key) {
            $scope.page.CURRPAGE = 1;
            $scope.data.panels = [];
            $scope.params[key] = !$scope.params[key];
            requestData();
        };
    },
]);
